<template>
    <div>
        <p>
            Protractor Companion App | Version {{ version }}
        </p>
    </div>
</template>
  
<script lang="ts" setup>
const version = process.env.VUE_APP_VERSION;
</script>
